import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
  Select,
  MenuItem,
  FormControl,
  NativeSelect,
} from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import Rating from "@material-ui/lab/Rating";
import TokenPool from "../components/SearchTokenPools/TokenPool";
import Table from "../components/Misc/Table";
import Doughnut from "../assets/Doughnut.png";

import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import LineTable from "../components/Misc/LineTable";
import axios from "axios";
// import TokenPool from "../components/SearchTokenPools/TokenPool";
// import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import { getTableData, getGraphqlData } from "../redux/actions/web3Actions";
import InputWithDropdown from "../components/Inputs/InputWithDropdown";
const useStyles = makeStyles((theme) => ({
  root: {
    height: 200,
  },
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    padding: "1.5rem",
    height: "13rem",

    flexWrap: "wrap",
  },

  pieBox: {
    marginTop: "4rem",
    padding: "0px 1rem",
    display: "flex",
    justifyContent: "space-between",
  },
  list: {
    alignItems: "center",
    margin: "3rem 1rem 0px 1rem",
  },
  table: {
    border: "1px solid pink",
    margin: "2rem 0px",
    width: "50%",
    height: "100%",
    // alignItems: "center",
  },
  BigCard: {
    background: "#FFFFFF",
    marginTop: "2rem",
    borderRadius: "8px",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "1.5rem",
    width: "45%",
    // height: "30rem",
  },
  head: {
    height: "4rem",
    backgroundColor: "rgba(246, 48, 169, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // textAlign: "center",
    padding: "0px 1rem",
  },
  Card3: {
    width: "100%",
    backgroundColor: "white",
    padding: "2.5rem",
    borderRadius: "8px",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",

    height: "30rem",
    marginTop: "3rem",
  },
  headingText: {
    fontWeight: "600",
    // flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3rem",
    marginBottom: "1rem",
    marginLeft: "1rem",
  },
  dot: {
    backgroundColor: ({ color }) => color,
    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  pinkDot: {
    backgroundColor: "#f630a9",
    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  container: {
    padding: "1rem",
    maxWidth: "110rem",
  },
  percentage: {
    fontSize: "3.5rem",
    fontWeight: "700",
    margin: "1rem 1rem 0rem 0rem",
  },
  grid: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "space-between",
  },
  grid2: {
    display: "flex",
    alignItems: "center",
    marginTop: "1.4rem",
  },
  capBold: {
    fontSize: "1.4rem",
    fontWeight: "700",
  },
  bodyText: {
    // fontWeight: "600",
    // flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flex3: {
    display: "flex",
    alignItems: "center",
    padding: "0.5rem 0rem",
  },
  row: {
    display: "flex",
    height: "4.3rem",
    alignContent: "center",
    borderBottom: "1px solid rgba(246, 48, 169, 0.2)",
    // backgroundColor: "aqua",
    padding: "0px 1rem",
    justifyContent: "space-between",
  },
  stars: {
    marginLeft: "12rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "space-around",
    flex: 1,
    height: "100%",
    padding: "1rem 0px",
    marginBottom: "2rem",
    // backgroundColor: "red",
  },
  star: {
    flex: 1,
    // backgroundColor: "yellow",
    display: "flex",
    justifyContent: "space-around",
  },
  flex: {
    display: "flex",
    marginBottom: "2rem",
    // justifyContent:"space-between"
    // alignItems: "center",
  },
  flex2: {
    display: "flex",
    // background:"red",
    width: "50%",
    // marginBottom: "2rem",
    // alignItems: "center",
  },
  card: {
    background: "white",
    padding: "1rem 2rem",
    width: "100%",
    borderRadius: "8px",
  },
  bold: {
    fontWeight: "600",
    fontSize: "1.3rem",
  },
  barColor: {
    backgroundColor: "#F630A9",
  },
  barRoot: {
    height: "1.2rem",
    borderRadius: "8px",
  },
  track: {
    backgroundColor: "#F630A9",
    // width: "2rem",
  },
  rail: {
    backgroundColor: "#F630A9",
    // height: "1rem",
    // width: "7rem",
  },
  thumb: {
    color: "#F630A9",
    width: "1.3rem",
    height: "1.3rem",
  },
  pairsSelect: {
    width: "fit-content",

    background:
      theme.palette.type === "dark"
        ? "linear-gradient(264.59deg, #262C47 -9.52%, rgba(38, 44, 71, 0) 112.5%)"
        : " linear-gradient(84.55deg, #FFFFFF -57.11%, rgba(255, 255, 255, 0.5) 158.73%)",
    border: "1px solid red",

    color: theme.palette.type === "dark" ? "#fff" : "#192039",
    height: "3rem",
    display: "flex",
    borderRight: "1px solid #ccc",
    paddingRight: "1.2rem",
    paddingLeft: "1.2rem",
    fontWeight: "500",
    fontSize: "1.2rem",
    margin: "1.5rem 0 0 1rem",
    // lineHeight: "2.4rem",
  },
  formControl: {
    // margin: theme.spacing(1),
    marginLeft: 30,
    minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
    fontSize: "1.2rem",
    margin: "1.5rem 0 0 1rem",
  },
  pairMenuItem: {
    border: "1px solid red",
  },
}));

const Dot = (color) => {
  const classes = useStyles(color);

  return <Box className={classes.dot}></Box>;
};

const heading = [
  "Posts Outstanding",
  "Date to Complete ",
  "Status",
  "URL",
  "Project Post Brief",
];
const SearchTokenPools = () => {
  const MyTypography = ({ children }) => {
    return (
      <Typography style={{ fontSize: "1rem", textAlign: "center" }}>
        {children}
      </Typography>
    );
  };

  const [options, setOptions] = useState([{ name: "" }]);
  const [selectedTableData, setSelectedTableData] = useState([]);

  
  const classes = useStyles();

  const value = 4;

  function valuetext(value) {
    return `${value}°C`;
  }
  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }
  const Theading = ["Vesting Dates", "Token Amount", "Status", " "];

  const marks = [
    {
      value: 100,
      label: "1 star/500",
    },
    {
      value: 80,
      label: "2 star/500",
    },
    {
      value: 60,
      label: "3 star/500",
    },
    {
      value: 40,
      label: "4 star/500",
    },
    {
      value: 20,
      label: "5 star/500",
    },
  ];
  const [totalInvested, setTotalInvested] = useState(0);
  const [outstandingTokens, setOutstandingTokens] = useState(0);
  const [filteredGraphData, setfilteredGraphData] = useState([]);

  const [campaign, setCampaign] = useState([]);
  console.log("OPTIONS HEHE", options);

  console.log({ totalInvested });
  const dispatch = useDispatch();
  // const [options, setOptions] = useState([]);

  const isUser = useSelector((state) => state.ui.isUser);
  const tableData = useSelector((state) => state.ui.tableData);
  const graph = useSelector((state) => state.ui.graphQLData);
  console.log("IS USER", isUser);
  console.log("GRAPH DATA ", graph);
  console.log("TABLE DATA", tableData);

  useEffect(() => {
    if (isUser?.kol?._id) {
      dispatch(getTableData(isUser?.kol?._id));
    }
  }, [isUser]);

  useEffect(() => {
    if (isUser?.kol?._id) {
      dispatch(getGraphqlData(isUser?.kol?._id));
    }
  }, [isUser]);

  useEffect(() => {
    // tableData.map((d) => {
    //   setOptions((prev) => [
    //     ...prev,
    //     { name: d.campaignId.campaignName, id: d.campaignId._id },
    //   ]);
    // });

    // setOptions((prev) => [
    //   ...prev,
    //   tableData.map((d) => {
    //     return {
    //       name: d.campaignName,
    //       id: d.campaignId,
    //     };
    //   }),
    // ]);
    setOptions(
      tableData.map((d) => {
        return {
          name: d.campaignId.campaignName,
          id: d.campaignId._id,
        };
      })
    );

    console.log("selectedTableData =======", selectedTableData[0]);
  }, [tableData]);

  useEffect(() => {
    if (selectedTableData[0]?.invested) {
      setTotalInvested(selectedTableData[0].invested);
      setOutstandingTokens(selectedTableData[0].tokenOutstanding);
    }
  }, [selectedTableData]);

  const handleChange = (event) => {
    let eventValue = event.target.value.split(",")[0];
    let id = event.target.value.split(",")[1];

    console.log("event", id, eventValue);
    const filtered = graph.filter((value, i) => {
      // console.log("INSIDE", value[0].projectBrief?.campaignName);
      return value[0].projectBrief?.campaignName === eventValue;
    });
    // console.log("filtered", filtered);
    setCampaign(eventValue);
    setfilteredGraphData(filtered);
    const again = tableData.filter((t) => {
      return t.campaignId._id == id;
    });
    setSelectedTableData(again);
    console.log({ again });
  };

  console.log("Calc=========", totalInvested, outstandingTokens);

  console.log("PARSED", filteredGraphData);
  return (
    <>
      <Box className={classes.container}>
        <Box style={{ display: "flex" }}>
          <Typography
            style={{ margin: "2rem 0rem" }}
            className={classes.capBold}
          >
            Select Your Campaign
          </Typography>

          <FormControl className={classes.formControl}>
            <NativeSelect
              // value={campaign}
              onChange={handleChange}
              defaultValue={campaign}
              displayEmpty
              // className={classes.pairsSelect}
              classes={{ nativeInput: classes.selectInput }}
              className={classes.selectEmpty}
              // inputProps={{ "aria-label": "age" }}
            >
              <option value="select">None</option>
              {options.map((opt) => {
                return (
                  <option
                    className={classes.pairMenuItem}
                    value={[opt.name, opt.id]}
                    id={opt.id}
                  >
                    {opt.name}
                  </option>
                );
              })}
            </NativeSelect>
            {/* <FormHelperText>With visually hidden label</FormHelperText> */}
          </FormControl>
        </Box>
        <Grid container className={classes.card}>
          <Grid className={classes.subGrid}>
            <Typography
              style={{ margin: "2rem 0rem" }}
              className={classes.capBold}
            >
              Invested Pools (Total) : {tableData?.length}
            </Typography>
            <Typography>Total</Typography>

            <Typography className={classes.capBold}>
              {totalInvested - outstandingTokens} USDT / {totalInvested} USDT
            </Typography>
            <Box className={classes.flex}>
              <Box>
                <Box className={classes.grid2}>
                  <Box className={classes.dot}></Box>
                  <Typography> Recieved </Typography>
                </Box>
                <Typography
                  style={{ marginLeft: "1rem" }}
                  className={classes.bold}
                >
                  {totalInvested - outstandingTokens} USDT
                </Typography>
              </Box>

              <Box style={{ marginLeft: "9.3rem" }}>
                <Box className={classes.grid2}>
                  <Box className={classes.pinkDot}></Box>
                  <Typography> Outstanding </Typography>
                </Box>
                <Typography
                  style={{ marginLeft: "1rem" }}
                  className={classes.bold}
                >
                  {outstandingTokens} USDT
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid className={classes.subGrid}>
            {/* <Typography>Invested Poossssssssssssssssssssssssssssssssssssssssssssls (Total)</Typography> */}
          </Grid>
        </Grid>

        <Table
          selectedTableData={selectedTableData}
          title="Claimable Tokens"
          Theading={Theading}
        />
        <LineTable
          filteredGraphData={filteredGraphData}
          heading={heading}
          kol={true}
        />
      </Box>
    </>
  );
};

export default SearchTokenPools;
